export default ["informational", "neutral", "success", "warning", "error", "attention"];
